export {
  init,
  setProgress,
}

let circle, radius, circumference;

function init(id) {
  circle = document.querySelector(`#${id}>circle`);
  radius = circle.r.baseVal.value;
  circumference = radius * 2 * Math.PI;

  circle.style.strokeDasharray = `${circumference} ${circumference}`;
  circle.style.strokeDashoffset = `${circumference}`;
}

function setProgress(fraction) {
  const offset = circumference - fraction * circumference;
  circle.style.strokeDashoffset = offset;
}
